// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".borderMainClientProfile[data-v-1e23740c]{\n  border-bottom:1px solid #F9F9F9;\n}\n.minWContent[data-v-1e23740c]{\n  min-width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
